"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.to-string");var _typeof2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/typeof"));require("core-js/modules/es6.number.constructor");require("core-js/modules/es6.function.name");require("core-js/modules/es6.regexp.split");require("core-js/modules/web.dom.iterable");
























































































var _aliOss = _interopRequireDefault(require("@/utils/aliOss"));
var _vuedraggable = _interopRequireDefault(require("vuedraggable")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { vuedraggable: _vuedraggable.default }, name: 'TaskSkillParams', data: function data() {return { newadd: true, title: '', paramsList: [], imageList: [], audioList: [], videoList: [], taskSkill: {}, addData: { id: '', taskId: '', flowId: '', skillId: '' }, rules: { mapId: [{ required: true, message: '请选择地图', trigger: 'blur' }], name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }], workDays: [{ required: true, validator: this.workDayValidate, trigger: 'blur' }], robotIds: [{ required: true, message: '请选择机器人', trigger: 'blur' }], workTime: [{ required: true, message: '请输入作业时间', trigger: 'blur' }], frequency: [{ required: true, message: '请输入巡逻频率', trigger: 'blur' }], isCircle: [{ required: true, message: '请输入作用周期', trigger: 'blur' }], postAction: [{ required: true, message: '请输入完成动作', trigger: 'blur' }] } };}, mounted: function mounted() {var self = this;self.paramsList = [];self.handleClearParams();}, methods: { resetFun: function resetFun() {// 重置
      this.searchData.sn = '';this.searchData.name = '';}, handleClearParams: function handleClearParams() {var self = this;self.paramsList = [];self.imageList = [];self.videoList = [];self.audioList = [];},
    handleGetParams: function handleGetParams(taskSkill) {
      var self = this;
      self.handleClearParams();
      self.paramsList = taskSkill.paramList;
      self.addData.taskId = taskSkill.taskId;
      self.addData.flowId = taskSkill.flowId;
      self.addData.skillId = taskSkill.id;
      self.taskSkill = taskSkill;
      // 组装addData
      self.paramsList.forEach(function (param) {
        var aValue = param.value;
        if (param.dataType === 'time') {
          aValue = self.handleFormatDate(param.value);
          param.value = aValue;
        }
        if (param.display === 'audio') {
          if (param.value) {
            self.audioList = param.value.split(',');
          }
        } else if (param.display === 'img') {
          if (param.value) {
            self.imageList = param.value.split(',');
            console.log('self.imageList', self.imageList);
          }
        } else if (param.display === 'video') {
          if (param.value) {
            self.videoList = param.value.split(',');
          }
        }
        /* if (param.display === 'checkbox') {
            var tpv = typeof param.value
            if (tpv === 'string') {
              aValue = param.value.split(',')
              console.log(aValue)
              param.value = aValue
            }
          }
           var tp = typeof param.option
          if (param.option && tp === 'string') {
            var po = param.option
            po = po.replace(/{/g, '')
            po = po.replace(/}/g, '')
            po = po.replace(/"/g, '')
            po = po.split(',')
            param.option = po
            console.log(po)
          } */

      });
    },
    handleFormatDate: function handleFormatDate(time) {
      if (time && typeof time === 'string') {
        var time1 = time.split(':');

        if (time1.length > 2) {
          var data1 = new Date();
          data1.setHours(time1[0]);
          data1.setMinutes(time1[1]);
          data1.setSeconds(time1[2]);
          return data1;
        }
      }

      return time;
    },
    handleDelList: function handleDelList(list, index) {
      list.splice(index, 1);
    },
    onsuccess: function onsuccess(res, display) {
      var self = this;
      var iconUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;
      if (display === 'audio') {
        self.audioList.push(iconUrl);
      } else if (display === 'img') {
        self.imageList.push(iconUrl);
      } else if (display === 'video') {
        self.videoList.push(iconUrl);
      }
    },
    fnUploadRequest: function fnUploadRequest(option) {
      var path = 'temi/taskParams';
      _aliOss.default.ossUploadFile(option, path);
    },
    updateMenu: function updateMenu(item) {// 修改操作
      var self = this;
      var frequency = '0';
      if (item.frequency > 0) {
        frequency = '1';
      }
      self.addData = {
        id: item.id,
        name: item.name,
        frequency: frequency,
        frequencyNum: item.frequency,
        postAction: item.postAction ? item.postAction + '' : '1',
        isCircle: item.isCircle ? '1' : '0',
        mapId: item.mapId,
        startTime: item.startTime,
        endTime: item.endTime,
        isEnable: item.isEnable ? '1' : '0',
        workDays: [],
        robotIds: [] };

      if (item.workDays) {
        var days = item.workDays.split(',');
        self.wDays = [0, 1, 2];
        days.forEach(function (day) {
          self.addData.workDays.push(Number(day));
        });
      }
      if (item.startTime && item.endTime) {
        var time1 = item.startTime.split(':');
        var time2 = item.endTime.split(':');

        if (time1.length > 2 && time2.length > 2) {
          var data1 = new Date();
          data1.setHours(time1[0]);
          data1.setMinutes(time1[1]);
          data1.setSeconds(time1[2]);
          var data2 = new Date();
          data2.setHours(time1[0]);
          data2.setMinutes(time1[1]);
          data2.setSeconds(time1[2]);
          self.addData.workTime = [data1, data2];
        }
      }
      self.getTaskRobots(item.id);
    },
    handleGetResult: function handleGetResult() {// 返回最终的结果
      var self = this;
      self.paramsList.forEach(function (param) {
        if (param.display === 'checkbox') {
          var tpv = (0, _typeof2.default)(param.value);
          if (tpv !== 'string') {
            param.value = param.value.toString();
          }
        } else if (param.display === 'audio') {
          if (self.audioList) {
            param.value = self.audioList.toString();
          }
        } else if (param.display === 'img') {
          if (self.imageList) {
            param.value = self.imageList.toString();
          }
        } else if (param.display === 'video') {
          param.value = self.videoList.toString();
        }
        tpv = (0, _typeof2.default)(param.option);
        if (tpv !== 'string' && param.option) {
          param.option = param.option.toString();
        }
      });
      self.taskSkill.paramList = self.paramsList;
      // return self.paramsList
      return self.taskSkill;
    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.paramsList.forEach(function (param) {
            if (param.display === 'checkbox') {
              var tpv = (0, _typeof2.default)(param.value);
              if (tpv !== 'string') {
                param.value = param.value.toString();
              }
            } else if (param.display === 'audio') {
              if (self.audioList) {
                param.value = self.audioList.toString();
              }
            } else if (param.display === 'img') {
              if (self.imageList) {
                param.value = self.imageList.toString();
              }
            } else if (param.display === 'video') {
              param.value = self.videoList.toString();
            }
            tpv = (0, _typeof2.default)(param.option);
            if (tpv !== 'string' && param.option) {
              param.option = param.option.toString();
            }
          });
          var path = '/api/temi/robot/task/' + self.addData.taskId + '/flow/' + self.addData.flowId + '/taskSkill/' + self.addData.skillId + '/params';
          self.postData(path, self.paramsList, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            // 组装addData
            self.paramsList.forEach(function (param) {
              var aValue = param.value;
              if (param.dataType === 'time') {
                aValue = self.handleFormatDate(param.value);
                param.value = aValue;
              }
              /* if (param.display === 'checkbox') {
                  var tpv = typeof param.value
                  if (tpv === 'string') {
                    aValue = param.value.split(',')
                    console.log(aValue)
                    param.value = aValue
                  }
                }
                 var tp = typeof param.option
                if (param.option && tp === 'string') {
                  var po = param.option
                  po = po.replace(/{/g, '')
                  po = po.replace(/}/g, '')
                  po = po.replace(/"/g, '')
                  po = po.split(',')
                  param.option = po
                  console.log(po)
                } */

            });
            // self.$emit('refreshTaskList', self.addData.id)
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/temi/robot?id=' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        title: '',
        longContent: '',
        orderNum: 0,
        icon: '' };

    },
    openOrgDialog: function openOrgDialog(robotId) {
      var self = this;
      self.robotId = robotId;
      self.getIns(robotId);
      self.getOrganziationList();
      self.modOrg = true;
    },
    closeOrgDialog: function closeOrgDialog() {
      this.modOrg = false;
      this.insId = '';
      this.robotId = '';
      this.$refs.orgTree.setCheckedKeys([]);
    },
    checkFn: function checkFn(node, data) {
      var currKey = node.id;
      this.$refs.orgTree.setCheckedKeys([currKey]);
      this.insId = currKey;
    },
    getIns: function getIns(robot) {
      var self = this;
      self.getData('api/temi/robot/ins/' + robot, {}, function (res) {
        if (res.robotInsInfo !== null) {
          self.insId = res.robotInsInfo.insId;
          if (self.insId !== '') {
            self.$refs.orgTree.setCheckedKeys([self.insId]);
          }
        }
      });
    } } };exports.default = _default;